module.exports = __webpack_public_path__ + "img/black-lock-alt.56f62b2.svg";